<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <!-- Filtros -->
    <v-card>
      <div class="row mb-2 mt-0">
        <div class="col-md-12" v-if="list_access">
          <div class="col-md-12 elevation-0" style="background: white">
            <div class="row pt-5">
              <div class="col-md-2 pt-0">
                <v-autocomplete :value="emitter" :items="emitters" item-text="name" item-value="id" return-object autocomplete="off" label="Empresa" class="pt-0 mt-0" @input="$emit('update:emitter', $event)"></v-autocomplete>
              </div>

              <div class="col-md-2 pt-0">
                <v-menu
                  ref="desde_menu"
                  v-model="desde_menu"
                  :close-on-content-click="false"
                  :return-value.sync="desde_selected"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="desde_selected" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="desde_menu = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.desde_menu.save(desde_selected)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2 pt-0">
                <v-menu
                  ref="hasta_menu"
                  v-model="hasta_menu"
                  :close-on-content-click="false"
                  :return-value.sync="hasta_selected"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="hasta_selected" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="cost_centers" label="Centro de Costo" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-2 pt-0">
                <v-combobox v-model="concepto_selected" autocomplete="off" item-text="name" item-value="id" :items="conceptos" label="Concepto" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col pt-0" style="display: flex; justify-content: end">
                <v-btn color="info" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Matriz -->
    <v-card class="mt-3">
      <v-card-title>
        <span class="text-uppercase">{{ page_title }}</span>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
      </v-card-title>

      <v-alert v-if="filtrado" dense text type="info" class="mx-4 mb-0">
        Con filtro de centro de costo o concepto no se muestra el bloque de Disponibilidades: los filtros acotan los conceptos y dejaría de espejar el movimiento de fondos.
      </v-alert>

      <v-progress-linear v-if="cargando" indeterminate color="info"></v-progress-linear>

      <TablaResultados :data="data" :loading="cargando" by_blocks empty_text="Seleccioná un período y presioná Buscar." @cell-click="onCellClick"></TablaResultados>
    </v-card>

    <ModalTable
      :title="detalle_title"
      :open="open_detalle"
      :cancel="closeDetalle"
      :items="detalle_items"
      :headers="detalle_headers"
      :max_width="1100"
      :loading="loading_detalle"
      @cell-click="onDetalleCellClick"
    />

    <ModalTesoreriaMovement
      modal_title="Movimiento de Tesorería"
      :formBtn="movimiento_formBtn"
      :dialog="dialog_movimiento"
      :item="movimiento_item"
      :service="tesoreriaMovementService"
      @updateDialog="updateDialogMovimiento"
      @loadList="onMovimientoGuardado"
    />

    <DialogReasignarConcepto
      :open="dialog_reasignar"
      :item="reasignar_item"
      :conceptos="conceptos"
      :cost_centers="cost_centers"
      @cancel="closeReasignar"
      @reasignado="onReasignado"
    />
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import TablaResultados from "./TablaResultados.vue";
import ModalTable from "@/components/ModalTable.vue";
import ModalTesoreriaMovement from "@/views/Treasury/TesoreriaMovements/Modal.vue";
import DialogReasignarConcepto from "@/components/DialogReasignarConcepto.vue";
import ResultadosDetalleMixin from "./ResultadosDetalleMixin.vue";

const MAX_DIAS = 31;

export default {
  components: { TablaResultados, ModalTable, ModalTesoreriaMovement, DialogReasignarConcepto },
  mixins: [GenericMixin, RolMixin, ExportMixin, ResultadosDetalleMixin],
  props: { emitter: Object, emitters: Array, emitters_loaded: Boolean },
  data() {
    return {
      page_title: "Resultados por Día",
      data: null,
      desde_menu: false,
      hasta_menu: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      cost_center_selected: null,
      concepto_selected: null,
      cost_centers: [],
      conceptos: [],
    };
  },
  watch: {
    emitter() {
      if (this.emitter && this.emitter.id) this.filter();
    },
  },
  computed: {
    cargando() {
      return this.loading || !this.emitters_loaded;
    },
    filtrado() {
      return this.cost_center_selected != null || this.concepto_selected != null;
    },
  },
  mounted() {
    this.loadCombos();
    this.filter();
  },
  methods: {
    loadCombos() {
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.cost_centers = response.result;
      });
      generalService.filter({ enabled: "all" }, Constant.SECTION_CONCEPTOS).then((response) => {
        this.conceptos = response.result;
      });
    },
    getFilterParams() {
      return {
        group_by: "day",
        from: this.desde_selected,
        to: this.hasta_selected,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
        concepto: this.concepto_selected != null ? this.concepto_selected.id : null,
        emitter: this.emitter ? this.emitter.id : null,
      };
    },
    // Una columna por dia: mas de un mes vuelve la matriz ilegible. El backend tambien lo valida.
    validPeriod() {
      const desde = new Date(this.desde_selected);
      const hasta = new Date(this.hasta_selected);
      if (hasta < desde) {
        this.$toast.error("La fecha 'hasta' no puede ser anterior a la fecha 'desde'.", "Error");
        return false;
      }
      if (Math.round((hasta - desde) / 86400000) + 1 > MAX_DIAS) {
        this.$toast.error("El período no puede superar los " + MAX_DIAS + " días.", "Error");
        return false;
      }
      return true;
    },
    filter() {
      // Sin empresa no se consulta: mezclaría todas.
      if (!this.emitter || !this.emitter.id) return;
      if (!this.validPeriod()) return;
      this.loading = true;
      const emitterId = this.emitter ? this.emitter.id : null;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_RESULTADOS)
        .then((response) => {
          // Si cambió la empresa mientras llegaba la respuesta, esta ya no corresponde.
          if (emitterId !== (this.emitter ? this.emitter.id : null)) return;
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    // La columna es el dia: el detalle de la cuenta se acota a esa unica fecha.
    getRangoCuenta(cell) {
      return [cell.columna_id, cell.columna_id];
    },
    exportFile() {
      if (!this.validPeriod()) return;
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_RESULTADOS, param, "Resultados-Tesoreria-Diario.xlsx");
    },
  },
};
</script>
